import { isIOS } from '../../services/native';

/**
 * StickyPageHeader — iOS-only sticky header wrapper.
 * On iOS: sticks at viewport top with padding-top so content starts below status bar.
 * The blank padding area = status bar sits there.
 * Then page title appears below status bar.
 * On Android/Web: renders children normally (no change).
 */
export default function StickyPageHeader({ children, className = '', borderBottom = true, noPadding = false }) {
  if (!isIOS) {
    return <div className={className}>{children}</div>;
  }

  return (
    <div
      className={`sticky top-0 z-30 bg-[var(--page-bg,#f8fafc)] ${borderBottom ? 'border-b border-surface-200' : ''} ${!noPadding ? 'pb-2' : ''} ${className}`}
      style={{ paddingTop: 'env(safe-area-inset-top, 0px)' }}
    >
      {children}
    </div>
  );
}
